// SPDX-License-Identifier: AGPL-3.0-or-later

import {z} from 'zod';

export const BoosterBadgeConfigSchema = z.object({
	booster_role_enabled: z.boolean().default(false).describe('Whether new booster role grants are enabled'),
	badge_inventory_enabled: z.boolean().default(false).describe('Whether badge inventory settings are enabled'),
});

export const BoosterBadgeConfigUpdateRequest = z.object({
	booster_role_enabled: z.boolean().optional(),
	badge_inventory_enabled: z.boolean().optional(),
});

export type BoosterBadgeConfigUpdateRequest = z.infer<typeof BoosterBadgeConfigUpdateRequest>;
